angular.module('app').controller(
    'MfaLoginCtrl',
    [
        '$window',
        '$location',
        '$log',
        '$rootScope',
        '$scope',
        '$cookies',
        'aprgettext',
        'AprimaAnalytics',
        'Bridge',
        'configuration',
        'ConsentService',
        'ContentAttributeService',
        'GatewayFactory',
        'LocalStorageRepository',
        'LogOffService',
        'LoginAssistanceRepository',
        'PatientPortalStorageRepository',
        'SessionService',
        'TransitionManager',
        function (
            $window,
            $location,
            $log,
            $rootScope,
            $scope,
            $cookies,
            gettext,
            AprimaAnalytics,
            Bridge,
            configuration,
            ConsentService,
            ContentAttributeService,
            GatewayFactory,
            LocalStorageRepository,
            LogOffService,
            LoginAssistanceRepository,
            PatientPortalStorageRepository,
            SessionService,
            TransitionManager
        ) {
            'use strict';

            if($location.$$url === '/signout')
            {
                var idhint = LocalStorageRepository.getIdentityHint();
                if(idhint === null || idhint === undefined || idhint === '') {
                    LogOffService.logoff().then(function () {
                        TransitionManager.transition({appRoute: 'login'});
                    });
                }
                else {
                    callIdentityLogoutRedirectUrl();
                }
            }
            else if(!($location.$$search && $location.$$search.code))
            {
                $scope.splash = true;
            }

            clear();

            $log.info('MfaLoginCtrl starting up');

            AprimaAnalytics.sendPageView('/Logon');
            LogOffService.logoff();
            SessionService.resetSessionParams();
            PatientPortalStorageRepository.removeActivePatient();

            if(!configuration.DEV_HOSTED) {
                ContentAttributeService.getClientConfig()
                    .then(function (data) {

                        LocalStorageRepository.setClientURL(data.hostUrl);
                        LocalStorageRepository.setClientID(data.clientId);

                        onLoad();
                    }).catch(function () {
                        $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                    });
            } else {
                onLoad();
            }

            if($location.$$search && $location.$$search.code)
            {
                GatewayFactory.identityTokenLogin(LocalStorageRepository.getClientID(), $location.$$search.code, null)
                    .then(function () {
                        // Broadcast event to start application timeout logic.
                        // Please see 'modules\app\app.js' for application timeout configuration and documentation.

                        //set cookie for auto login for a day
                        $rootScope.$broadcast('IdleStartWatch');

                        SessionService.setPatientAuthenticated(true);
                        if (SessionService.getPracticeConsentAccepted() === true) {
                            SessionService.setDisplayDashboardToolbar(true);
                            SessionService.setShowHeaderNavigationMenu(true);
                            TransitionManager.transition({appRoute: 'dashboard'});
                        }
                        else {
                            SessionService.setDisplayDashboardToolbar(false);
                            SessionService.setShowHeaderNavigationMenu(false);
                            TransitionManager.transition({appRoute: 'loginconsent'});
                        }
                    }, function (err) {
                        $scope.splash = true;
                        $scope.registrationIssue = err.message;
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function routeUsername()
            {
                if ($scope.loading) {
                    return;
                }

                if ($scope.routeUsernameForm.$invalid) {
                    $scope.submitted = true;
                    return;
                }

                $scope.loading = true;

                GatewayFactory.routeUsername( $scope.routerModel.clientId, $scope.routerModel.userName, $scope.routerModel.gateway ? $scope.routerModel.gateway.prefix : null)
                    .then(function (userRegistrationResult) {
                        if(userRegistrationResult && userRegistrationResult.IsFailure===false && userRegistrationResult.UsernameRegistrationState) {
                            var username = $scope.routerModel.userName;
                            if(userRegistrationResult.UsernameRegistrationState === 'Registered'){
                                $scope.splash = false;
                                callPARRedirectUrl($scope.routerModel.userName);
                            }
                            else if(userRegistrationResult.UsernameRegistrationState === 'NotRegistered' && userRegistrationResult.RegisterNewMFA){
                                clear();
                                $scope.mfaRegister = true;
                                $scope.registerModel.userName = username;
                            }
                            else if(userRegistrationResult.UsernameRegistrationState === 'NotRegistered' && !userRegistrationResult.RegisterNewMFA){
                                clear();
                                $scope.mfaLogin = true;
                                $scope.loginModel.userName = username;
                            }
                            else
                            {
                                $scope.errorMessage = 'Login Failed.  Please Contact Support.';
                            }
                        }
                        else
                        {
                            $scope.errorMessage = 'Login Failed.  Please Contact Support.';
                        }
                    }, function (err) {
                        $scope.errorMessage = err.message;
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function register()
            {
                if ($scope.loading) {
                    return;
                }

                if ($scope.registerForm.$invalid) {
                    $scope.submitted = true;
                    return;
                }

                $scope.loading = true;

                GatewayFactory.register( $scope.registerModel.clientId, $scope.registerModel.userName, $scope.registerModel.password, $scope.registerModel.gateway ? $scope.registerModel.gateway.prefix : null)
                    .then(function (userRegistrationResult) {
                        if(userRegistrationResult && userRegistrationResult.IsFailure===false && userRegistrationResult.UserData) {
                            var username = $scope.registerModel.userName;
                            clear();
                            $scope.mfaConfirm = true;
                            $scope.confirmModel.emailAddress = userRegistrationResult.UserData.EmailAddress;
                            if(userRegistrationResult.UserData.DateOfBirth && userRegistrationResult.UserData.DateOfBirth !== new Date('0001-01-01T00:00:00Z'))
                            {
                                $scope.confirmModel.dateOfBirth = new Date(userRegistrationResult.UserData.DateOfBirth);
                            }
                            $scope.confirmModel.personId = userRegistrationResult.UserData.PersonUid;
                            $scope.confirmModel.userName = username;
                        }
                        else if(userRegistrationResult.ErrorCode === 401)
                        {
                            $scope.errorMessage = 'Invalid Login.';
                        }
                        else
                        {
                            errorRegister($scope.registerModel.userName, 'Registration Failed.  Please contact support.');
                        }
                    }, function (err) {
                        errorRegister($scope.registerModel.userName, err.message);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function errorRegister(username, message)
            {
                clear();
                $scope.registerModel.userName = username;
                $scope.mfaRegister = true;
                $scope.errorMessage = message;
            }

            function login() {
                //do not try logging in while trying to login.
                if ($scope.loading) {
                    return;
                }

                if ($scope.loginForm.$invalid) {
                    $scope.submitted = true;
                    return;
                }

                $scope.loading = true;

                GatewayFactory.login( $scope.loginModel.clientId, $scope.loginModel.userName, $scope.loginModel.password, $scope.loginModel.gateway ? $scope.loginModel.gateway.prefix : null)
                    .then(function () {
                        // Broadcast event to start application timeout logic.
                        // Please see 'modules\app\app.js' for application timeout configuration and documentation.
                        $rootScope.$broadcast('IdleStartWatch');

                        SessionService.setPatientAuthenticated(true);
                        if (SessionService.getNewPasswordRequired() === true) {
                            SessionService.setDisplayDashboardToolbar(false);
                            SessionService.setShowHeaderNavigationMenu(false);
                            TransitionManager.transition({appRoute: 'changepassword'});
                        }
                        else if (SessionService.getPracticeConsentAccepted() === true) {
                            SessionService.setDisplayDashboardToolbar(true);
                            SessionService.setShowHeaderNavigationMenu(true);
                            TransitionManager.transition({appRoute: 'dashboard'});
                        }
                        else {
                            SessionService.setDisplayDashboardToolbar(false);
                            SessionService.setShowHeaderNavigationMenu(false);
                            TransitionManager.transition({appRoute: 'loginconsent'});
                        }
                    }, function (err) {
                        errorLogin($scope.loginModel.userName, err.message);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function errorLogin(username, message)
            {
                clear();
                $scope.loginModel.userName = username;
                $scope.mfaLogin = true;
                $scope.errorMessage = message;
            }

            function confirm()
            {
                if ($scope.loading) {
                    return;
                }

                if ($scope.confirmationForm.$invalid) {
                    $scope.submitted = true;
                    return;
                }

                $scope.loading = true;
                var personId = $scope.confirmModel.personId;
                var dob = $scope.confirmModel.dateOfBirth;
                var email = $scope.confirmModel.emailAddress;
                var oldUserName = $scope.confirmModel.userName;
                GatewayFactory.confirm($scope.confirmModel.clientId, $scope.confirmModel.personId, $scope.confirmModel.dateOfBirth, $scope.confirmModel.emailAddress, $scope.confirmModel.userName, $scope.registerModel.gateway ? $scope.registerModel.gateway.prefix : null)
                    .then(function (userRegistrationResult) {
                        if(userRegistrationResult && userRegistrationResult.IsFailure===false && userRegistrationResult.IdentityResponseDto)
                        {
                            var username = $scope.confirmModel.emailAddress;
                            clear();
                            $scope.mfaRouter = true;
                            $scope.routerModel.userName = username;
                            if(userRegistrationResult.ErrorCode === $scope.personIdentityServiceErrorCodes.AlreadyRegistered)
                            {
                                $scope.errorMessage = 'You are already registered with multifactor credentials.';
                            }
                            else
                            {
                                var instructions = userRegistrationResult.IdentityResponseDto.VerificationMessage;
                                $scope.mfaNextSteps = instructions;
                                $scope.verficationLink = userRegistrationResult.IdentityResponseDto.VerificationUrl;
                            }
                            //$scope.registerForm = false;
                        }
                        else{
                            errorConfirm(personId, dob, email, oldUserName, 'Confirmation Failed.  Please contact support.');
                        }
                    }, function (err) {

                        errorConfirm(personId, dob, email, oldUserName, err.message);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function errorConfirm(personId, dob, email, username, errorMessage)
            {
                clear();
                $scope.confirmModel.personId = personId;
                $scope.confirmModel.dateOfBirth = dob;
                $scope.confirmModel.emailAddress = email;
                $scope.confirmModel.userName = username;
                $scope.mfaConfirm = true;
                $scope.errorMessage = errorMessage;
            }

            function cancel()
            {
                clear();
                $scope.mfaRouter = true;
            }

            function onLoad() {
                clear();
                $scope.mfaRouter = true;
                $scope.errorMessage = '';
                $scope.submitted = false;
                $scope.loading = false;
                $scope.gateways = _.map(_.cloneDeep(configuration.GATEWAYS), function (g) {
                    g.display = g.prefix + ' - ' + g.url;
                    return g;
                });

                $scope.loginAssistanceInfo = null;
                $scope.personIdentityServiceErrorCodes = {
                    'NotFound': 420,
                    'MissingFirstName': 421,
                    'MissingLastName': 422,
                    'MissingFullName': 423,
                    'MissingEmail': 424,
                    'MissingDOB': 425,
                    'AlreadyRegistered': 426
                };
                loadPracticeInfo();
                getLoginAssistanceInfo();
            }

            function clear()
            {
                $scope.mfaRouter = false;
                $scope.mfaRegister = false;
                $scope.mfaLogin = false;
                $scope.mfaConfirm = false;
                $scope.errorMessage = '';
                setModels();
            }

            function setModels()
            {
                $scope.routerModel = {
                    clientId: LocalStorageRepository.getClientID() || '0',
                    userName: LocalStorageRepository.getUserName() || '',
                    gateway: null,
                };
                $scope.registerModel = {
                    clientId: LocalStorageRepository.getClientID() || '0',
                    userName: '',
                    password: '',
                    gateway: null,
                };
                $scope.loginModel = {
                    clientId: LocalStorageRepository.getClientID() || '0',
                    userName: '',
                    password: '',
                    gateway: null,
                };
                $scope.confirmModel = {
                    clientId: LocalStorageRepository.getClientID() || '0',
                    personId: '',
                    dateOfBirth: '',
                    emailAddress: '',
                    userName: '',
                    gateway: null,
                };
                $scope.practiceModel = {
                    practiceName: '',
                    practiceTagline: '',
                };
            }

            function loadPracticeInfo() {
                ContentAttributeService.getPracticeInfo(true)
                    .then(function (practiceInfo) {
                        $scope.practiceModel.practiceName = practiceInfo.practiceName;
                        $scope.practiceModel.practiceTagline = practiceInfo.practiceTagline;
                    })
                    .catch(function () {
                        $scope.practiceModel.practiceName = '';
                        $scope.practiceModel.practiceTagline = '';
                    });
            }

            function getLoginAssistanceInfo() {
                LoginAssistanceRepository.getLoginAssistanceInformation(LocalStorageRepository.getClientID())
                    .then(function (data) {
                        $scope.loginAssistanceInfo = data;
                        if(data.CustomPortalFooter)
                        {
                            data.CustomPortalFooter = data.CustomPortalFooter.replace(/(\r\n|\n|\r)/g, '<br>');
                        }
                        $scope.assistanceInfoLoaded = true;
                    })
                    .catch(function () {
                        $scope.errorMessage = gettext('Unable to retrieve Login Assistance.');
                    });
            }

            function callIdentityLogoutRedirectUrl() {
                GatewayFactory.callIdentityLogoutRedirectUrl().then(function(url) {
                    var idhint = LocalStorageRepository.getIdentityHint();
                    $window.location.href = url + '&id_token_hint=' + idhint;
                }).catch(function(error) {
                    $scope.error = error;
                });
            }

            function callPARRedirectUrl(username) {
                $scope.loading = true;
                GatewayFactory.callPARRedirectUrl(username).then(function(url) {
                    $window.location.href = url;
                }).catch(function(error) {
                    $scope.error = error;
                }).finally(function() {
                    $scope.loading = false;
                });
            }
            $scope.callIdentityLogoutRedirectUrl = callIdentityLogoutRedirectUrl;
            $scope.callPARRedirectUrl = callPARRedirectUrl;
            $scope.getLoginAssistanceInfo = getLoginAssistanceInfo;
            $scope.routeUsername = routeUsername;
            $scope.register = register;
            $scope.confirm = confirm;
            $scope.cancel = cancel;
            $scope.login = login;
        }
    ]
);


